<template>
  <div class="custom-actions">
     <div class="card card-default">
          <div class="card-header">
            <i :class="icon"></i> <strong>{{ title }}</strong>
          </div>
          <div class="card-body">
            <slot name="content"></slot>
          </div>
     </div>
  </div>
</template>

<script>
  export default {
    name: 'card',

    props: {
      icon: {
        type: String,
      },

      title: {
        type: String,
        required: true,
      },
    },
  }
  </script>
